import React, { useState, useEffect } from 'react'
import { MessageSeverity } from 'constants/message'
import IcoInfo from 'resources/images/app/ico_info.png'
import IcoWarning from 'resources/images/app/ico_warning.png'
import IcoSuccess from 'resources/images/app/ico_success.png'
import IcoError from 'resources/images/app/ico_error.png'
import './messageHistory.css'
import { format } from 'date-fns'
import { Typography } from '@airbus/components-react/components'

const MessageHistory = (props) => {
  const message = props.message
  const [icon, setIcon] = useState(IcoInfo)
  const [date, setDate] = useState('')
  const [sender, setSender] = useState('')
  const [fullContent, setFullContent] = useState('')

  useEffect(() => {
    // Severity
    if (message) {
      switch (message.level) {
        case MessageSeverity.WARNING:
          setIcon(IcoWarning)
          break
        case MessageSeverity.SUCCESS:
          setIcon(IcoSuccess)
          break
        case MessageSeverity.ERROR:
          setIcon(IcoError)
          break
        default:
          setIcon(IcoInfo)
          break
      }
    }

    // Date, sender, content
    const dt = format(new Date(message.date), 'HH:mm:ss')
    setDate(dt)
    setSender(message.sender)
    // Add to message's content the amasis-code of the message if available
    const messageFullContent = message.content
      ? message.content +
        (message.code !== null && message.code !== undefined && message.code !== '' ? ' [' + message.code + ']' : '')
      : '-'
    setFullContent(messageFullContent)
  }, [message])

  return (
    <div className='messageHistory'>
      <div className='severity'>
        <img src={icon} title='message severity' alt='message severity' />
      </div>
      <Typography className='time'>{date}</Typography>
      <Typography className='sender'>{sender ? sender + ': ' : ''}</Typography>
      <Typography>{fullContent}</Typography>
    </div>
  )
}

export default MessageHistory
